export default __webpack_public_path__ + "static/2-e1ccd3d93a5ad505f8f37b89f8d48a35.jpg";